import React from 'react';
import {flowerCompositionContract as contract} from './flowerComposition';

const headings = {'0603':'실제 꽃·꽃봉오리', '0604':'실제 잎·가지 등', '6702':'조화·인조 잎·과실',
  '4602':'조물재료로 형태를 만든 제품', '6913':'장식용 도자기', '9405':'조명기구'};
const valueLabel = (field, value) => contract.fields[field]?.options?.[value] || '확인 자료 없음';
const ruleLabels = {'GRI1; Chapter06 Note2':'통칙 제1호·제6류 주 제2호','GRI3(a),3(b)':'통칙 제3호 가목·나목',
  'GRI3(a)':'통칙 제3호 가목','GRI3(b)':'통칙 제3호 나목',
  'GRI3(c)':'통칙 제3호 다목','accessory_or_GRI5_review':'부속품·포장재 적용 조건'};
const stateLabels = {requires_accessory_comparison:'부속품 범위 검토 필요',blocked_pending_note2:'앞선 주 규정 판단 대기',
  blocked_pending_3a:'앞선 호의 구체성 비교 대기',not_derived:'적용하지 않음',requires_review:'추가 검토 필요'};
const sourceLink = source => {
  const text = source.source_excerpt || '';
  const url = text.match(/Original page:\s*(https:\/\/[^\s]+)/)?.[1] || text.match(/^Source:\s*(https:\/\/[^\s]+)/)?.[1];
  if (!url) return null;
  try { const parsed = new URL(url); return ['www.wcoomd.org','rulings.cbp.gov'].includes(parsed.hostname) ? url : null; } catch { return null; }
};

/** Read-only comparison: deliberately has no answer, confirmation or report action. */
export default function MixedFlowerComparisonPanel({comparison, paused = false}) {
  if (paused || !comparison || comparison.scope !== 'whole_heading_hypothesis' || comparison.final !== false) return null;
  const directions = (comparison.competing_directions || []).filter(d=>/^\d{4}$/.test(d.heading) && d.selected === false);
  const components = Array.isArray(comparison.evidence) ? comparison.evidence : [];
  const names = Object.fromEntries(components.map(c => [c.id, c.label]));
  const observation = (component, field) => {
    const values = [...new Set((component.observations || []).filter(o=>o.field===field).map(o=>o.value))];
    return values.length === 1 ? valueLabel(field, values[0]) : values.length ? '자료의 값이 서로 다름' : '확인 자료 없음';
  };
  return <section aria-label="혼합 꽃다발 전체 비교" style={{padding:14,marginBottom:14,background:'#f3f7fc',border:'1px solid #b3c6dc',borderRadius:8}}>
    <strong>전체 꽃다발의 분류 조건 비교</strong>
    <p>아래 호들을 함께 검토하고 있습니다. 전체 상품의 호와 확정 세번은 아직 정하지 않았습니다.</p>
    {comparison.reason && <p>{comparison.reason}</p>}
    {!!directions.length && <div><strong>함께 대조할 호와 적용 조건</strong><ul>{directions.map(d=><li key={d.heading}>
      <strong>제{d.heading}호 · {headings[d.heading] || '추가 경합 호'}</strong><p>{d.condition}</p>
    </li>)}</ul></div>}
    {!!components.length && <table style={{width:'100%',marginTop:10,textAlign:'left'}}>
      <caption style={{textAlign:'left'}}>확인한 구성품과 전체 장식에서의 역할</caption>
      <thead><tr><th>구성품</th><th>역할</th><th>제거했을 때</th></tr></thead>
      <tbody>{components.map(c=><tr key={c.id}><th scope="row">{c.label}</th><td>{observation(c,'role')}</td><td>{observation(c,'removal_effect')}</td></tr>)}</tbody>
    </table>}
    {!!comparison.missing_observations?.length && <div><strong>추가로 확인할 상품 정보</strong>
      <ul>{comparison.missing_observations.map((item,i)=><li key={i}>{names[item.component_id] || '해당 구성품'} · {contract.fields[item.field]?.label || '상품 정보'}</li>)}</ul>
    </div>}
    {!!comparison.competing_observations?.length && <div><strong>함께 대조할 자료</strong>
      <ul>{comparison.competing_observations.map((item,i)=><li key={i}>{names[item.component_id] || '해당 구성품'} · {contract.fields[item.field]?.label || '상품 정보'}{item.reason ? ` — ${item.reason}` : ''}</li>)}</ul>
    </div>}
    {!!comparison.remaining_checks?.length && <div><strong>아직 남은 검토 조건</strong><ul>{comparison.remaining_checks.map((item,i)=><li key={i}>{item}</li>)}</ul></div>}
    <details><summary>적용 근거와 비교 순서</summary>
      {(comparison.legal_sequence || []).map((item,i)=><p key={i}><strong>{ruleLabels[item.rule] || '관련 규정'}</strong> · {stateLabels[item.status] || '검토 필요'}<br/>{item.reason || '전체 상품에 대한 적용 여부를 검토합니다.'}</p>)}
      <p>수량·중량·가액 하나만으로 전체 호를 결정하지 않습니다. 전체 호를 정한 뒤 소호와 한국 국내세분을 이어서 계산합니다.</p>
      {(comparison.sources || []).map((source,i)=>{const url=sourceLink(source); return url && <p key={i}><a href={url} target="_blank" rel="noreferrer">{url.includes('cbp.gov')?'관세당국 비교 사례':'WCO 원문'} 확인 ↗</a></p>;})}
    </details>
  </section>;
}
